import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function TopBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="sticky top-0 z-50 border-b border-ink-700 bg-ink-950/95 backdrop-blur" data-id="element-203" data-mp="231lu7olslp3j">
      <div className="mx-auto flex w-full max-w-page flex-col items-center gap-1 px-5 py-2.5 text-center sm:flex-row sm:justify-between sm:px-8 sm:text-left" data-id="element-204" data-mp="1y42gcpt0bec4">
        <p className="display text-sm text-bone sm:text-base" data-id="element-205" data-mp="2qsr8w0fzybc9">✂ Nuevo Nivel™</p>
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-ash" data-id="element-206" data-mp="2ltn19e8q0lo1">
          Precio de lanzamiento cierra en{' '}
          <span className="tabular text-alert" data-id="element-207" data-mp="2h1mx19lmb6ln">
            {hours}:{minutes}:{seconds}
          </span>
        </p>
      </div>
    </div>;
}